import {Button} from '@/components-v2/atoms/Button/Button'
import {Text} from '@/components-v2/atoms/Text/Text'
import {Breadcrumb} from '@/components-v2/molecules/Breadcrumb/Breadcrumb'
import {usePromotionTypes} from '@/hooks/usePromotionTypes'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useNavigate} from 'react-router-dom'

const promotionTypeBreadcrumbs = [
  {
    href: '/',
    label: '',
  },
  {
    href: ROUTES.SELECT_PROMOTION_TYPE,
    label: 'Promotions',
  },
  {
    href: ROUTES.CREATE_PROMOTION,
    label: 'Create Promotion',
  },
]

const PromotionTypeCard = ({promotion}) => {
  const navigate = useNavigate()

  const handleCreateNewPromotion = () => {
    navigate('/products/create-promotion', {
      state: {
        promotionType: promotion.type,
      },
    })
  }

  const handleCopyPromotion = promotionId => {
    navigate(`/products/create-promotion/${promotionId}`, {
      state: {
        promotionId,
        isDuplicating: true,
      },
    })
  }

  return (
    <div
      className="flex flex-col justify-between gap-6 rounded-xl bg-[var(--color-background-layer-01)] p-4 text-white"
      data-testid={`promotion-card-${promotion.type}`}
    >
      <div>
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <Text variant="bold">{promotion.title}</Text>
            <p className="mt-1 text-base italic text-[var(--color-text-secondary)]">{promotion.description}</p>
          </div>
          <div className="flex-shrink-0">
            <Button variant="secondary" size="medium" iconTrailing="chevron_right" onClick={handleCreateNewPromotion}>
              Start New
            </Button>
          </div>
        </div>
      </div>

      {promotion.latestPromotionName && (
        <div data-testid="recent-promotion">
          <Button
            variant="secondary"
            size="large"
            iconTrailing="chevron_right"
            className="!w-full justify-between rounded-[16px] !border !border-[var(--color-border-divider)] !px-4 !font-normal !text-[var(--color-text-secondary)] "
            onClick={() => handleCopyPromotion(promotion.latestPromotionId)}
          >
            {promotion.latestPromotionName}
          </Button>
        </div>
      )}
    </div>
  )
}

export const SelectPromotionType = () => {
  const {promotionTypes, isLoading, error} = usePromotionTypes()

  if (isLoading) {
    return <div className="flex min-h-screen items-center justify-center bg-black text-white">Loading...</div>
  }

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-black text-white">
        Error loading promotion types
      </div>
    )
  }

  return (
    <div className="min-h-screen text-white">
      <div className="container mx-auto">
        <Breadcrumb breadcrumbs={promotionTypeBreadcrumbs} />
        <div className="px-4 pb-8 pt-4">
          <Text headingLevel={3}>Select Promotion Type</Text>
          <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
            {promotionTypes?.map(promotion => (
              <PromotionTypeCard key={promotion.type} promotion={promotion} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
